module.exports = __webpack_public_path__ + "img/prakerja.1ac8fcaf.webp";